import { getConfig } from '@/config/config.ts';
import type { LegalEntity } from '@/model/LegalEntity.ts';
import { createApi } from '@reduxjs/toolkit/query/react';
import type { Alert } from '../alerts/model.ts';
import { webApiResponseBaseQuery } from './webApiResponseBaseQuery.ts';

const prefixUrl = getConfig().prefixUrl ?? '';

export const alertApi = createApi({
  reducerPath: 'alertApi',
  keepUnusedDataFor: 3_600, // By defaut keep query data 1h even if unused
  baseQuery: webApiResponseBaseQuery,
  endpoints: (builder) => ({
    getAlerts: builder.query<Alert[], LegalEntity>({
      query: (entity:LegalEntity) => ({
        method: 'GET',
        url: `${prefixUrl}/alerts/crms`,
        params: {
          legalEntity: entity
        },
      }),
      keepUnusedDataFor: 30, // keep unused results for 30s in cache
      transformResponse: ({ data: alerts }) => alerts as Alert[],
    }),
    getAlertsForDesk: builder.query<Alert[], LegalEntity>({
      query: (entity:LegalEntity) => ({
        method: 'GET',
        url: `${prefixUrl}/alerts/desks`,
        params: {
          legalEntity: entity
        },
      }),
      keepUnusedDataFor: 30, // keep unused results for 30s in cache
      transformResponse: ({ data: alerts }) => alerts as Alert[],
    }),
    getTabAlerts: builder.query<Alert[], string>({
      query: (rootId) => ({
        method: 'GET',
        url: `${prefixUrl}/alerts/roots`,
        params: {
          rootId: rootId
        },
      }),
      keepUnusedDataFor: 30, // keep unused results for 30s in cache
      transformResponse: ({ data: alerts }) => alerts as Alert[],
    }),
  }),
});

export const selectTabAlert = (rootId: string) => alertApi.endpoints?.getTabAlerts.select(rootId);

export const {
  useGetAlertsQuery, // alerts for landing page, desk view
  useGetAlertsForDeskQuery,
  useLazyGetAlertsQuery, // alerts for landing page, portfolio view 
  useLazyGetAlertsForDeskQuery,
  useGetTabAlertsQuery, // alerts for Root
  useLazyGetTabAlertsQuery,
} = alertApi;
